const removeUndefinedFields = (obj) => {
    console.log(obj)
    let newObj = Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));
    console.log(newObj)
    return newObj;
  };
  export default removeUndefinedFields;